import { createListenerMiddleware } from '@reduxjs/toolkit';
import { logout } from '../slices/auth';
import { Token, RefreshToken, Workspace } from '../../constants/keys';

export const authMiddleware = createListenerMiddleware();

// middleware responsible for removing user-related information from storage after logging out
authMiddleware.startListening({
  actionCreator: logout,
  effect: () => {
    localStorage.removeItem(Token);
    localStorage.removeItem(RefreshToken);
    localStorage.removeItem(Workspace);
  },
});
